import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { isSameDay } from 'date-fns';

import { FilterVehicleType } from '@src/app/enum/filters-vehicle.enum';
import { IFilterVehicle, IFilterVehicleOption, ISubmitFilters } from '@src/app/interfaces/filters-vehicle.interface';
import { EventService } from '@commons/services/event/event.service';
import { LanguageService } from '@shared/services/language.service';
import { EventTypeEnum } from '@commons/enums/event-type.enum';

@Component({
  selector: 'app-filters-events',
  templateUrl: './filters-events.component.html',
  styleUrls: ['./filters-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiltersEventsComponent implements OnInit {

  @Output() public onChangeFilters$: EventEmitter<any> = new EventEmitter();
  @Output() public toogleDatePicker$: EventEmitter<void> = new EventEmitter();

  @Input() public form: FormGroup;
  @Input() public selectedTab: EventTypeEnum;
  @Input() public isVisibleDatepicker: boolean;
  @Input('selectedDatesInCalendar') public set setSelectedDateCalendar(data: Date[]) {
    this._selectedDateCalendar = data?.length ? [...data] : null as any;

    if (this._selectedDateCalendar) {
      this.ifDateDayIsSame = isSameDay(data[0], data[1]);
    }
  }
  public ifDateDayIsSame: boolean;
  public _selectedDateCalendar: Date[];

  public filterTypeAlarmConfig: IFilterVehicle = {
    filterLabel: this.translate.instant('type'),
    type: FilterVehicleType.Group,
    dropdownLabel: this.translate.instant('showOnlyGroup'),
    options: [],
  };
  public filtersAlarmTypesCurrentFilters: ISubmitFilters;

  public filterEventTypeFuelConfig: IFilterVehicle = {
    filterLabel: this.translate.instant('type'),
    type: FilterVehicleType.Group,
    dropdownLabel: this.translate.instant('showOnlyGroup'),
    options: [
      { label: this.translate.instant('fuel-status.refueling'), value: 1, data: { Id: 1 } },
      { label: this.translate.instant('fuel-status.loss'), value: 2, data: { Id: 2 } },
    ],
  };
  public filtersEventTypeFuelCurrentFilters: ISubmitFilters;

  public filterEventTypeAreaConfig: IFilterVehicle = {
    filterLabel: this.translate.instant('type'),
    type: FilterVehicleType.Group,
    dropdownLabel: this.translate.instant('showOnlyGroup'),
    options: [
      { label: this.translate.instant('area-event-type.entry'), value: 1, data: { Id: 1 } },
      { label: this.translate.instant('area-event-type.leaves'), value: 2, data: { Id: 2 } },
    ],
  };
  public filterEventTypeAreaCurrentFilters: ISubmitFilters;

  public loading: boolean;
  public readonly langauge: string = this.languageService.current;
  public readonly EVENT_TYPE = EventTypeEnum;

  constructor(
    private translate: TranslateService,
    private eventService: EventService,
    private languageService: LanguageService,
  ) { }

  ngOnInit(): void {
    this.eventService.getEventActionForAlarm().subscribe(
      (result) => {
        this.filterTypeAlarmConfig = {
          ...this.filterTypeAlarmConfig,
          options: result.map((item: any) => ({ label: item.Nm, value: item.Id, data: item })) as IFilterVehicleOption[],
        }
      }
    );
  }

  public onSearchEnter(): void {

  }

  public onClearEnter(): void {

  }

  public onInputFocus(data: any): void {

  }

  public onSubmitFilters(data: ISubmitFilters, filterData: IFilterVehicle): void {
    if (data.selectedControlValue) {
      const selectedItem = this.filterTypeAlarmConfig.options.find(item => item.value === data.selectedControlValue);
      this.filtersAlarmTypesCurrentFilters = {...data};
      this.form.get('EventActionTypeAlarm')?.setValue(selectedItem?.data);
      return;
    }
    this.form.get('EventActionTypeAlarm')?.setValue(null);
  }

  public onSubmitFiltersEventTypeFuel(data: ISubmitFilters, filterData: IFilterVehicle): void {
    if (data.selectedControlValue) {
      this.filtersAlarmTypesCurrentFilters = {...data};
      this.form.get('EventActionTypeFuel')?.setValue({ Id: data.selectedControlValue });
      return;
    }
    this.form.get('EventActionTypeFuel')?.setValue(null);
  }

  public onSubmitFiltersEventTypeArea(data: ISubmitFilters, filterData: IFilterVehicle): void {
    if (data.selectedControlValue) {
      this.filtersAlarmTypesCurrentFilters = {...data};
      this.form.get('EventActionTypeArea')?.setValue({ Id: data.selectedControlValue });
      return;
    }
    this.form.get('EventActionTypeArea')?.setValue(null);
  }

}
